import { spacing } from '@scality/core-ui';
import styled from 'styled-components';

// Styled table components
export const StyledTable = styled.table`
  width: 100%;
  table-layout: auto;
  border-collapse: collapse;
  box-sizing: border-box;
  margin: ${spacing.r24} 0;
`;

export const StyledThead = styled.thead`
  box-sizing: border-box;
`;

export const StyledTbody = styled.tbody`
  box-sizing: border-box;
`;

export const StyledTr = styled.tr`
  box-sizing: border-box;
  display: table-row;
`;

export const StyledTh = styled.th`
  box-sizing: border-box;
  display: table-cell;
  align-items: center;
  gap: ${spacing.r16};
  height: 2.286rem;
  color: ${(props) => props.theme.textPrimary};
  font-weight: bold;
  overflow: hidden;
  border-bottom: 1px solid ${(props) => props.theme.backgroundLevel3};
  padding-right: ${spacing.r16};
  padding-left: ${spacing.r16};
  text-align: left;
  white-space: nowrap;
`;

export const StyledTd = styled.td`
  box-sizing: border-box;
  display: table-cell;
  padding-right: ${spacing.r16};
  padding-left: ${spacing.r16};
  height: 2.286rem;
  color: ${(props) => props.theme.textPrimary};
  overflow: hidden;
  border-bottom: 1px solid ${(props) => props.theme.backgroundLevel3};
  text-align: left;
  word-break: break-word;
`;
